export const cbhpmEditions = {
  2004: 'CBHPM 3ª Edição',
  2005: 'CBHPM 4ª Edição',
  2008: 'CBHPM 5ª Edição',
  2010: 'CBHPM 2010',
  2012: 'CBHPM 2012',
  2014: 'CBHPM 2014',
  2016: 'CBHPM 2016',
  2018: 'CBHPM 2018',
  2020: 'CBHPM 2020',
};

export function getName(value) {
  return cbhpmEditions[value];
}
